@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<!-- Error Message -->
@if (error && !loading) {
  <mat-card class="error-card">
    <mat-card-content>
      <div class="error-message">
        <mat-icon color="warn">error</mat-icon>
        <p>{{ error }}</p>
      </div>
    </mat-card-content>
  </mat-card>
}

<!-- Empty State -->
@if (transactionDetails.length === 0 && !loading && !error) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No transaction details found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

<!-- Table Container -->
@if (transactionDetails.length > 0 && !loading && !error) {
  <div class="table-container">
    <table mat-table [dataSource]="transactionDetails" class="transaction-details-table">
      <!-- ID Column -->
      <ng-container matColumnDef="transaction_reference_no">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.transaction_reference_no }}</td>
      </ng-container>
      <!-- Description (Source) Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.source }}</td>
      </ng-container>
      <!-- Amount Column -->
      <ng-container matColumnDef="transaction_amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.transaction_amount) }}</td>
      </ng-container>
      <!-- Date Column -->
      <ng-container matColumnDef="effective_date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let transaction">{{ formatDate(transaction.effective_date) }}</td>
      </ng-container>
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let transaction">
          @if (transaction.is_pending) {
            <div class="actions">
              <button mat-icon-button
                (click)="onEditPendingPayment(transaction)"
                [attr.aria-label]="'Edit pending payment ' + transaction.transaction_reference_no"
                class="action-button edit-button">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button
                (click)="onDeletePendingPayment(transaction)"
                [attr.aria-label]="'Delete pending payment ' + transaction.transaction_reference_no"
                class="action-button delete-button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="transaction-row"></tr>
    </table>
  </div>
}
